import React, { useContext } from 'react';
import { useTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite/no-important';
import { ThemeContext } from '../theme';

const propTypes = {
  level: PropTypes.number,
  className: PropTypes.string,
  canSelect: PropTypes.bool,
  textDecoration: PropTypes.oneOf(['none', 'overline', 'line-through', 'underline']),
  type: PropTypes.oneOf(['primary', 'secondary', 'success', 'warning', 'danger', 'error', 'info']),
  children: PropTypes.oneOf([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

const defaultProps = {
  level: 1,
  canSelect: true,
  textDecoration: 'none',
  type: 'secondary'
};

const Heading = (props) => {
  const { level } = props;
  const context = useContext(ThemeContext);
  const theme = useTheme();
  let heading;
  if (theme && theme.heading) {
    heading = theme.heading;
  } else {
    heading = context.theme.heading;
  }

  const styles = StyleSheet.create({
    heading: {
      textDecoration: props.textDecoration,
      ...heading[level]
    }
  });

  switch (props.level) {
    case 2:
      return (
        <h2 className={`${props.className} ${props.canSelect ? '' : 'noselect'} ${css(styles.heading)}`}>
          {props.children}
        </h2>);
    case 3:
      return (
        <h3 className={`${props.className} ${props.canSelect ? '' : 'noselect'} ${css(styles.heading)}`}>
          {props.children}
        </h3>);
    case 4:
      return (
        <h4 className={`${props.className} ${props.canSelect ? '' : 'noselect'} ${css(styles.heading)}`}>
          {props.children}
        </h4>);
    case 5:
      return (
        <h5 className={`${props.className} ${props.canSelect ? '' : 'noselect'} ${css(styles.heading)}`}>
          {props.children}
        </h5>);
    case 6:
      return (
        <h6 className={`${props.canSelect ? '' : 'noselect'} ${css(styles.heading)}`}>
          {props.children}
        </h6>);
    case 1:
    default:
      return (
        <h1 className={`${props.className} ${props.canSelect ? '' : 'noselect'} ${css(styles.heading)}`}>
          {props.children}
        </h1>);
  }
};

Heading.propTypes = propTypes;
Heading.defaultProps = defaultProps;

export { Heading };
